import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiDeleteConnectedOboardingElementDialogComponent } from './fi-delete-connected-oboarding-element-dialog.component';
import { FiDeleteConnectedOboardingElementDialogService } from './fi-delete-connected-oboarding-element-dialog.service';
import { FiAppTextSharedModule } from '@fi-app/shared/app-text';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';

@NgModule({
    imports: [CommonModule, FormsModule, FiAppTextSharedModule, MatInputModule, MatFormFieldModule, InfoIconModule],
    declarations: [FiDeleteConnectedOboardingElementDialogComponent],
    exports: [FiDeleteConnectedOboardingElementDialogComponent],
    providers: [FiDeleteConnectedOboardingElementDialogService],
})
export class FiDeleteConnectedOboardingElementDialogModule {}
